import React, { Component } from 'react'
import { NavLink } from 'react-router-dom'

export default class LogIn extends Component {
    render() {
        return (
            <React.Fragment>
                <div className="log">
                    <div className="container">
                        <div className="cont">
                            <form action="">
                                <input type="email" placeholder='Email' />
                                <input type="password" placeholder='Password' />
                                <button>LOGIN</button>
                                <NavLink to="/register">Create Account</NavLink>
                            </form>
                        </div>
                    </div>
                </div>
            </React.Fragment>
        )
    }
}
